<template>
    <b-button
        id="botao-pdf"
        :variant="notFound ? 'outline-secondary' : 'primary'"
        class="w-100 button"
        :style="{ 'cursor': loading ? 'wait' : !disabled ? 'pointer' : 'auto' }"
        @click="onButtonClick" :disabled="disabled"
    >
        <span :style="{ 'visibility': loading ? 'hidden' : 'visible' }">Abrir</span>
        <font-awesome-icon v-if="loading" id="loading-icon" icon="sync-alt" spin></font-awesome-icon>
    </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add([faSyncAlt]);

export default {
    props: {
        idVistoria: String,
    },
    components: {
        "font-awesome-icon": FontAwesomeIcon,
        BButton
    },
    data: function () {
        return {
            urlPDF: null,
            loading: false,
            notFound: false
        };
    },
    computed: {
        disabled: function() {
            return this.loading || this.notFound;
        },
    },
    methods: {
        splitTokenFromIdVistoria(idVistoria) {
            return idVistoria.split("_")[0] ?? null;
        },
        async getUrlPDF(token, idVistoria) {
            const uri = `/vistoria/v1/vistoria/url-download/${token}/${idVistoria}`;
            const response = await this.$api.get(uri);
            const urlPDF = response.data?.url;
            if(!urlPDF) {
                let invalidDataError = new Error("O backend retornou uma URL do PDF vazia");
                invalidDataError.code = "InvalidDataError";
                throw invalidDataError;
            }
            return urlPDF;
        },
        openUrlPDF() {
            window.open(this.urlPDF, "_blank").focus();
        },
        async onButtonClick(e) {
            try {
                if(this.urlPDF) {
                    this.openUrlPDF();
                    return;
                }
                this.loading = true;
                const idVistoria = this.$props.idVistoria;
                const token = this.splitTokenFromIdVistoria(idVistoria);
                this.urlPDF = await this.getUrlPDF(token, idVistoria);
                this.openUrlPDF();
                return;
            } catch (error) {
                if(error.response.status === 404 || error.code === "InvalidDataError") {
                    this.notFound = true;
                    setTimeout(() => this.notFound = false, 3500);
                    this.$toast.default("O PDF da vistoria ainda não foi gerado", {
                        position: "bottom",
                        duration: 3500
                    });
                } else {
                    this.$swal({
                        title: "Erro ao buscar URL do PDF",
                        icon: "error",
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: "Voltar",
                    });
                }
            } finally {
                this.loading = false;
            }
        }
    },
};
</script>

<style scoped lang="scss">
#botao-pdf {
    position: relative;
}

#loading-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

</style>
